'use client';

import { useOnMount } from '@base-ui/utils/useOnMount';
import { useIsoLayoutEffect } from '@base-ui/utils/useIsoLayoutEffect';
import { useRefWithInit } from '@base-ui/utils/useRefWithInit';
import { useAdapter } from "../use-adapter/useAdapter.mjs";
import { EventCalendarStore } from "./EventCalendarStore.mjs";
export function useEventCalendar(parameters, StoreClass) {
  const adapter = useAdapter(parameters.dateLocale);
  const ResolvedStoreClass = StoreClass ?? EventCalendarStore;
  const store = useRefWithInit(() => new ResolvedStoreClass(parameters, adapter)).current;
  useIsoLayoutEffect(() => store.updateStateFromParameters(parameters, adapter), [store, adapter, parameters]);
  useOnMount(store.disposeEffect);
  return store;
}